import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { v4 } from "uuid";

import { createCurrentDatetime } from "@tsp-core/datetime/utils";

import { NotificationData } from "../types";

export type ShowNotificationAction = PayloadAction<NotificationData>;
export type HideNotificationAction = PayloadAction<string>;

export const notifierSlice = createSlice({
  name: "@notifier/slice",
  reducerPath: "@notifier/slice",
  initialState: [] as Array<NotificationData>,
  reducers: {
    add: (notifications, action: ShowNotificationAction) => {
      return [action.payload, ...notifications];
    },
    remove: (notifications, action: HideNotificationAction) => {
      return notifications.filter((notification) => action.payload !== notification.uuid);
    },
  },
  selectors: {
    select: (notifications) => notifications,
  },
});

export const showNotification = createAsyncThunk(
  "@notifier/showNotification",
  async (payload: Omit<NotificationData, "uuid" | "createdAt">, { dispatch }) => {
    const uuid = v4();

    dispatch(
      notifierSlice.actions.add({
        uuid,
        createdAt: createCurrentDatetime(),
        ...payload,
      }),
    );

    if (!payload.isManual) {
      setTimeout(() => {
        dispatch(notifierSlice.actions.remove(uuid));
      }, 5000);
    }
  },
);
